/*
 * rule-window.js
 * Date windows for Store Manager rules (gift_map.rules, gift_map.spendRules,
 * discount_map.rules). Every rule may carry startsAt / endsAt as UTC ISO
 * strings; absent (or unparseable) means no limit. Start is inclusive, end is
 * exclusive. Liquid applies the same check at render time
 * (snippets/rule-in-window.liquid); this file repeats it in the browser so
 * cached page HTML corrects itself, and gives the cart scripts one helper.
 *
 * DOM contract for server-rendered markup (browser only):
 *   data-rule-starts / data-rule-ends   ISO strings of one rule. The element
 *                                       is hidden while now is outside them.
 *   data-rule-windows                   JSON [[startsAt|null, endsAt|null], ...].
 *                                       The element is hidden while none of the
 *                                       windows contains now.
 *   data-rule-alt                       with data-rule-starts/ends: instead of
 *                                       hiding, replace the text with this.
 * Hidden elements get the rule-window-hidden class (display: none !important).
 */
(function (root) {
  function parseTime(value) {
    if (value == null || value === '') return null;
    var ms = typeof value === 'number' ? value : Date.parse(String(value));
    return isNaN(ms) ? null : ms;
  }

  // now is epoch milliseconds; defaults to the current time.
  function inWindow(rule, now) {
    if (!rule || typeof rule !== 'object') return true;
    var at = now == null ? Date.now() : now;
    var start = parseTime(rule.startsAt);
    var end = parseTime(rule.endsAt);
    if (start != null && at < start) return false;
    if (end != null && at >= end) return false;
    return true;
  }

  function filterRules(rules, now) {
    return (Array.isArray(rules) ? rules : []).filter(function (rule) {
      return inWindow(rule, now);
    });
  }

  function windowsContain(windows, now) {
    if (!Array.isArray(windows) || !windows.length) return true;
    return windows.some(function (pair) {
      return inWindow({ startsAt: pair && pair[0], endsAt: pair && pair[1] }, now);
    });
  }

  root.ChillabRuleWindow = {
    parseTime: parseTime,
    inWindow: inWindow,
    filterRules: filterRules,
    windowsContain: windowsContain,
  };

  if (typeof document === 'undefined') return;

  var HIDDEN = 'rule-window-hidden';

  function injectStyle() {
    if (document.getElementById('rule-window-style')) return;
    var style = document.createElement('style');
    style.id = 'rule-window-style';
    style.textContent = '.' + HIDDEN + '{display:none !important}';
    (document.head || document.documentElement).appendChild(style);
  }

  function setHidden(el, hidden) {
    if (el.classList.contains(HIDDEN) !== hidden) el.classList.toggle(HIDDEN, hidden);
  }

  // A hidden tier option must not stay the selected one, or the buy box would
  // submit a product the shopper can no longer see.
  function fallBackFromHiddenOption(el) {
    var radio = el.querySelector && el.querySelector('input[type="radio"]');
    if (!radio || !radio.checked) return;
    var group = el.closest('fieldset') || document;
    var other = Array.prototype.slice
      .call(group.querySelectorAll('input[type="radio"][name="' + radio.name + '"]'))
      .filter(function (candidate) {
        return candidate !== radio && !candidate.closest('.' + HIDDEN);
      })[0];
    if (other) {
      other.checked = true;
      other.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply(scope) {
    var now = Date.now();
    (scope || document).querySelectorAll('[data-rule-starts], [data-rule-ends], [data-rule-windows]').forEach(function (el) {
      var inside = true;
      if (el.hasAttribute('data-rule-starts') || el.hasAttribute('data-rule-ends')) {
        inside = inWindow(
          { startsAt: el.getAttribute('data-rule-starts'), endsAt: el.getAttribute('data-rule-ends') },
          now
        );
      }
      if (inside && el.hasAttribute('data-rule-windows')) {
        try {
          inside = windowsContain(JSON.parse(el.getAttribute('data-rule-windows')), now);
        } catch (e) {
          inside = true;
        }
      }
      var alt = el.getAttribute('data-rule-alt');
      if (alt != null) {
        if (!inside && el.textContent !== alt) el.textContent = alt;
        return;
      }
      setHidden(el, !inside);
      if (!inside) fallBackFromHiddenOption(el);
    });
  }

  root.ChillabRuleWindow.apply = apply;

  injectStyle();
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      apply();
    }, 0);
  }

  apply();
  document.addEventListener('DOMContentLoaded', schedule);
  // The cart drawer and product sections re-render their HTML in place.
  if (typeof MutationObserver !== 'undefined') {
    var observe = function () {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) observe();
    else document.addEventListener('DOMContentLoaded', observe);
  }
  // A window can open or close while the page stays open.
  setInterval(schedule, 60000);
})(typeof window === 'undefined' ? globalThis : window);
